import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { WebsocketRequest, WebsocketService } from "./websocket";

/* eslint-disable @typescript-eslint/naming-convention */
interface SendEmailRequestData {
    recipient_email: string;
    recipient_name: string;
    subject: string;
    message_body: string;
}

interface SendEmailRequest extends WebsocketRequest {
    send_email_data: SendEmailRequestData;
}
/* eslint-enable @typescript-eslint/naming-convention */

@Injectable({
    providedIn: "root",
})
export class SendEmailDatabaseService {
    private requestType = "send_email";

    constructor(private websocket: WebsocketService) {}

    private makeRequest(data: SendEmailRequestData): Observable<any> {
        /* eslint-disable @typescript-eslint/naming-convention */
        return this.websocket.makeRequest({
            request_type: this.requestType,
            send_email_data: data,
            metadata: {},
        } as SendEmailRequest);
        /* eslint-enable @typescript-eslint/naming-convention */
    }

    public sendEmailRequest$(email: string, name: string, subject: string, body: string): Observable<any> {
        /* eslint-disable @typescript-eslint/naming-convention */
        const data = { recipient_email: email, recipient_name: name, subject, message_body: body };
        /* eslint-enable @typescript-eslint/naming-convention */
        return this.makeRequest(data);
    }
}
